import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

import Global from '../../../../../store/global-selectors';
import { ltlShipmentsGridMessages } from '../messages';

const ProNumber = ({ freightShipmentId }: { freightShipmentId: string }) => {
  const shipment = useSelector((state) => Global.selectEntitiesFreightShipmentById(state, { freightShipmentId }));

  return <>{shipment?.proNumber ?? ''}</>;
};

export const proNumber = {
  getMessageDescriptor: () => ltlShipmentsGridMessages.proNumber,
  name: <FormattedMessage {...ltlShipmentsGridMessages.proNumber} />,
  id: 'proNumber',
  width: 130,
  minWidth: 70,
  index: 1,
  render: (data: { id: string }) => <ProNumber freightShipmentId={data.id} />,
};
